import { CONTINUOUS_EDUCATION } from '../../../api/endpoints';
import request, {
  AxiosResult,
  AxiosResultDefaultError,
} from '../../../api/request';
import { AccountType } from '../../../types/account';
import {
  NonStructuredSectionClassroomLoaderFilters,
  NonStructuredSectionEditResponse,
  NonStructuredSectionSchedulesResponse,
  UpdateNonStructuredSectionSchedules,
  UpdateNonStructuredSectionBody,
} from './types';

export const getNonStructuredSectionActionRequest = (id: string | number) => {
  return request<NonStructuredSectionEditResponse>(
    CONTINUOUS_EDUCATION.SECTION(id),
  );
};

export const getNonStructuredSectionSchedulesActionRequest = (
  id: string | number,
) => {
  return request<NonStructuredSectionSchedulesResponse>(
    CONTINUOUS_EDUCATION.SECTION_SCHEDULES(id),
  );
};

export const updateNonStructuredSectionSchedulesActionRequest = (
  id: string | number,
  data: UpdateNonStructuredSectionSchedules,
) => {
  return request<NonStructuredSectionSchedulesResponse>(
    CONTINUOUS_EDUCATION.SECTION_SCHEDULES(id),
    {
      method: 'put',
      data,
    },
  );
};

export const getClassroomAvailabilityActionRequest = ({
  sectionId,
  ...params
}: NonStructuredSectionClassroomLoaderFilters & {
  sectionId: number | string;
}) => {
  const { sectionScheduleId, ...requiredFilters } = params;
  if (Object.values(requiredFilters).some((value) => value === undefined)) {
    return Promise.resolve<AxiosResult<any[], AxiosResultDefaultError>>(
      [] as any,
    );
  }
  return request<any[]>(
    CONTINUOUS_EDUCATION.SECTIONS_SCHEDULES_GET_CLASSROOM_AVAILABILITY,
    {
      params,
    },
  );
};

export const getEditResponsiblesActionRequest = (searchText: string) => {
  return request<AccountType[]>(
    CONTINUOUS_EDUCATION.SECTIONS_SCHEDULES_SEARCH_RESPONSABLE,
    {
      params: { search_text: searchText },
    },
  );
};

export const updateNonStructuredSectionActionRequest = (
  id: string | number,
  data: UpdateNonStructuredSectionBody,
) => {
  return request(CONTINUOUS_EDUCATION.SECTION(id), {
    method: 'PUT',
    data,
  });
};
